import React from "react";
import { Box, Button, Skeleton, Typography } from "@mui/material";

export default function DataState({ loading = false, title = "Nothing here yet", message, onRetry, compact = false }) {
  return (
    <Box role="status" aria-busy={loading} sx={{ width: "100%", maxWidth: compact ? 600 : 1180, mx: "auto", my: compact ? 0 : 2, px: 2, py: 2, textAlign: "center" }}>
      {loading ? <>
        <Typography sx={{ mb: 2, color: "#747767" }}>Loading…</Typography>
        <Box aria-hidden="true" sx={{ display: "grid", gridTemplateColumns: compact ? "1fr" : { xs: "1fr", sm: "repeat(3, 1fr)" }, gap: 2 }}>
          {Array.from({ length: 3 }, (_, index) => <Box key={index}>
            <Skeleton variant="rounded" height={compact ? 32 : 150} sx={{ '@media (prefers-reduced-motion: reduce)': { animation: 'none' } }} />
            {!compact && <Skeleton width="70%" height={32} />}
          </Box>)}
        </Box>
      </> : <>
        <Typography component="h3" sx={{ m: 0, fontWeight: 400, fontSize: "0.95rem", color: "#747767" }}>{title}</Typography>
        {message && <Typography sx={{ mt: 0.5, color: "#747767", fontSize: "0.875rem" }}>{message}</Typography>}
        {onRetry && <Button variant="text" onClick={onRetry} sx={{ mt: 0.5, textTransform: "none", fontSize: "0.875rem" }}>Try again</Button>}
      </>}
    </Box>
  );
}
